import React from "react";
import { Props } from "./type";
import styles from "./styles.scss";
import { FolderIcon } from "@common/folderIcon";
import { ColorIcon } from "@common/assets/colorIcon";
import { DirectionArrowIcon } from "@common/assets/directionArrowIcon";
import classNames from "classnames";

function hashCode(str: string) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
}

function generateRandomColor(name: string) {
  return `#${intToRGB(hashCode(name))}`;
}

function Project(props: Props) {
  const backgroundColor = generateRandomColor(props.project.name);

  const handleClick = () => {
    if (props.onToggle) {
      props.onToggle(props.project.uuid);
    }
  };

  return (
    <div
      className={classNames(styles.project, {
        [styles.selected]: props.isSelected,
      })}
      onClick={handleClick}
    >
      <div
        className={classNames(styles.colorIconWrapper, {
          [styles.checked]: props.isSelected,
        })}
        style={{
          backgroundColor: backgroundColor,
          borderColor: backgroundColor,
        }}
      />

      <p className={styles.name}>{props.project.name}</p>
    </div>
  );
}

export { Project };
